import i18n from '@/i18n'

export const ADVERT_TYPES = [
  'PRODUCTO',
  'SEÑALIZACIÓN'
]

export const ADVERT_TYPE_LABELS = {
  'PRODUCTO': i18n.t('PRODUCT'),
  'SEÑALIZACIÓN': i18n.t('SIGNALING')
}
